var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedZil0)",
    d: "m6.857 5.649l8.139 3.93l2.143-.943l-8.152-3.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedZil1)",
    d: "M6.857 5.649V7.77l5.666 2.73l-5.666 2.773v2.091L15 19.286v-2.1l-5.515-2.679L15 11.68v-2.1L6.857 5.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedZil2)",
    d: "m15 9.566l2.143-.93v2.1L15 11.67zm0 9.703l2.143-.935V11.8L15 12.742z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedZil0",
    x1: 15.432,
    x2: 4.833,
    y1: 18.836,
    y2: 14.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60AAAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#347181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedZil1",
    x1: 12,
    x2: 12,
    y1: 4.714,
    y2: 19.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#216B79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedZil2",
    x1: 13.714,
    x2: 18.429,
    y1: 17.357,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AC1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#216B79"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZil);
export default __webpack_public_path__ + "static/media/zil.250d73935a95ee6c7ac15a7d0cbbd80e.svg";
export { ForwardRef as ReactComponent };